import { computed, Injectable, WritableSignal, inject } from '@angular/core';
import {
    IReactionData,
    IReactionFavoriteModel,
    IReactionModel,
    IReactionSaveModel,
    IEmojiViewData,
} from '@fi-shared/fi-likes/fi-likes';
import { FiReactionType } from '@fi-shared/fi-likes/fi-likes-enums';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { ActionType, ObjectTypes } from '@fi-shared/types';
import { EmojiData } from '@ctrl/ngx-emoji-mart/ngx-emoji';
import { isDefined } from '@fi-shared/utils';
import { FiEmojiService } from '@fi-shared/fi-emoji-button/fi-emoji.service';

@Injectable()
export class FiLikesFactoryService {
    private readonly userDataService = inject(FiUserDataService);

    getNewCommonLikeInstance(objectId: number, objectType: ObjectTypes): IReactionModel {
        return {
            UserId: this.userDataService.getUserId(),
            UserFullName: this.userDataService.getUserFullName(),
            UserBusinessUnitName: this.userDataService.userData.BusinessUnitName,
            UserProfile: this.userDataService.getUserProfile(),
            ObjectType: objectType, // used for save
            ObjectId: objectId, // used for save
            ReactionType: FiReactionType.Like, // used for save
        };
    }

    getNewEmojiLikeInstance(objectId: number, objectType: ObjectTypes, data?: IReactionData): IReactionModel {
        return {
            UserId: this.userDataService.getUserId(),
            UserFullName: this.userDataService.getUserFullName(),
            UserBusinessUnitName: this.userDataService.userData.BusinessUnitName,
            UserProfile: this.userDataService.getUserProfile(),
            ObjectId: objectId, // used for save
            ObjectType: objectType, // used for save
            ReactionType: FiReactionType.Emoji, // used for save
            Data: data, // used for save
        };
    }

    getLikeInstanceForSave(reaction: IReactionModel): IReactionSaveModel {
        return {
            ObjectId: reaction.ObjectId,
            ObjectType: reaction.ObjectType,
            ReactionType: reaction.ReactionType,
            Data: reaction.Data,
        };
    }

    getFavoriteReactionInstance(date: Date, reactionData: IReactionData): IReactionFavoriteModel {
        return {
            ChangedOn: date.toISOString(),
            Data: reactionData,
        };
    }

    getReactionDataFromEmoji(emoji?: IEmojiViewData): IReactionData {
        return {
            Unified: emoji?.unified,
            Id: emoji?.id,
        };
    }

    updateReactions(reactions: WritableSignal<IReactionModel[]>, actionType: ActionType, reaction: IReactionModel) {
        const reactionUserId = reaction.UserId;
        reactions.update((reactions) => {
            // each message can have only one reaction per each user
            const newReactions = reactions.filter((r) => r.UserId !== reactionUserId);
            if (actionType === ActionType.Create) {
                newReactions.unshift(reaction);
            }
            return newReactions;
        });
    }

    isReactionDataEquals(reactionData: IReactionData, otherReactionData: IReactionData): boolean {
        return reactionData?.Unified === otherReactionData?.Unified;
    }
}
